<script lang="typescript">
    import { onDestroy } from "svelte";
    import { push } from "svelte-spa-router";

    onDestroy(() => window.scrollTo(0, 0));
</script>

<section class="justify-center h-screen overflow-y-hidden bg-primary">
    <div class="flex flex-col items-center justify-center h-full page-container bg-primary">
        <h1 class="mb-8 text-3xl font-normal text-white">No matches found. Please try again.</h1>

        <button
            class="px-4 mt-10 btn-secondary btn-sm lg:px-8"
            type="button"
            on:click={() => push("/")}
        >
            Start again
        </button>
    </div>
</section>
